(($) => {
	const toggleCategoryAndProduct = () => {
		"use strict";
		const el = {
			category: "wc-categories.default",
			categorySection: "#shop_section_category",
			productSection: "#shop_section_product",
		};

		let $categorySection;
		let $productSection;

		const defineVar = () => {
			$categorySection = $(el.categorySection);
			$productSection = $(el.productSection);
		};

		const init = () => {
			defineVar();
			$(window).on("elementor/frontend/init", function () {
				if (
					$categorySection.length &&
					$("body:not(.elementor-editor-active)").length
				) {
					exec();
				}
			});
		};

		const exec = () => {
			// eslint-disable-next-line no-undef
			elementorFrontend.hooks.addAction(
				"frontend/element_ready/wc-categories.default",
				// eslint-disable-next-line no-unused-vars
				function ($scope) {
					const hasCategory = $scope.find(".woocommerce .products").length > 0;
					if (hasCategory && !$(".woocommerce-shop").length) {
						$categorySection.fadeIn();
					} else {
						$productSection.fadeIn();
					}
				}
			);
		};

		init();
	};

	try {
		toggleCategoryAndProduct();
	} catch (error) {
		throw Error(error);
	}
	// eslint-disable-next-line no-undef
})(jQuery);
